/**
 * Shared flag indicating a group transform is active (a centroid pivot exists,
 * the Inspector gizmo is attached to it).
 *
 * While active, the gizmo manipulates the pivot — never a real SceneObject — so
 * the per-object undo-gizmo service must stand down (it records the whole group
 * as one CompositeCommand on drag end instead). This tiny module breaks what
 * would otherwise be an import cycle between the two services.
 */

let active = false;

export function setGroupDragActive(value: boolean): void {
    active = value;
}

export function isGroupDragActive(): boolean {
    return active;
}
